import type { ReviewResponseReviewerBasicInfo } from './reviewResponseReviewerBasicInfo';
import type { ReviewResponseReviewerSocial } from './reviewResponseReviewerSocial';

/**
 * 리뷰 작성자 요약 정보
 */
export type ReviewResponseReviewer = {
  /** 사용자 기본 정보 */
  basicInfo: ReviewResponseReviewerBasicInfo;
  /** 소셜 관계 정보 */
  social?: ReviewResponseReviewerSocial;
};
